module.exports = __webpack_public_path__ + "img/reset_blue.8212de14.svg";